<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent width="450">
      <v-card>
        <v-card-title class="title justify-space-between">
          <div>Register for Webinar</div>
          <div>
            <v-btn @click="onCancelClick" icon>
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text>
          <div class="sub-heading">
            How to trade to gain short term opportunities - Swing and Positional
            Trades
          </div>
          <div class="d-flex">
            <div class="name-text">by {{ by }}</div>
            <v-spacer></v-spacer>
            <v-chip color="#FFF1DB" class="chip">{{ level }}</v-chip>
          </div>
          <v-form ref="registerForm">
            Name
            <v-text-field
              dense
              outlined
              placeholder="Enter Name"
              :rules="[rule.required]"
              v-model="name"
            >
            </v-text-field>
            Email
            <v-text-field
              dense
              outlined
              placeholder="Enter Email"
              :rules="[rule.email]"
              v-model="email"
            >
            </v-text-field>
            Contact
            <v-text-field
              dense
              outlined
              placeholder="Contact Number"
              :rules="[rule.phone]"
              v-model="phone"
            >
            </v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            width="100%"
            height="46px"
            class="add-btn"
            color="primary"
            block
            @click="freeWebinarRegister"
            >Register</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <freeWebinarRegister :freeRegisterSuccess="freeRegisterSuccess" />
  </v-row>
</template>
<script>
import RULES from "@/common/fieldRules";
import apiUrl from "@/common/apiUrl";
import newAxios from "@/api/newAxios";
import freeWebinarRegister from "./freeWebinarRegisterDialog.vue";
export default {
  name: "registerDialog",
  data() {
    return {
      rule: RULES,
      name: "",
      email: "",
      phone: "",
      freeRegisterSuccess: {
        flag: false,
      },
    };
  },
  components: {
    freeWebinarRegister,
  },
  computed: {
    show() {
      return this.$store.state.webinar.RegisterModal.show;
    },
    id() {
      return this.$store.state.webinar.RegisterModal.id;
    },
    by() {
      return this.$store.state.webinar.RegisterModal.by;
    },
    level() {
      return this.$store.state.webinar.RegisterModal.level;
    },
  },
  methods: {
    onCancelClick() {
      this.$store.commit("webinar/showRegisterModal", { show: false });
      this.$refs.registerForm.reset();
    },
    freeWebinarRegister() {
      if (this.$refs.registerForm.validate()) {
        const onSuccess = () => {
          this.$store.commit("webinar/showRegisterModal", { show: false });
          this.$refs.registerForm.reset();
          this.eventBus.$emit("reload-webinar");
          this.freeRegisterSuccess.flag = true;
        };
        const onFailure = () => {};
        let data = new FormData();
        data.append("name", this.name);
        data.append("webinar", this.id);
        data.append("email", this.email);
        data.append("phone", this.phone);
        newAxios("post", apiUrl.FREE_WEBINAR_REGISTER, {
          data,
          onSuccess,
          onFailure,
          isTokenRequired: false,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  color: #fff;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.625rem;
  /* 130% */
  background: var(--Primary-Blue, #2d8cff);
}
.add-btn {
  border-radius: 6px;
  font-family: Avenir;
  font-size: 16px;
  font-weight: 500;
  line-height: 21.86px;
  text-align: center;
  text-transform: capitalize;
}
.sub-heading {
  font-family: Avenir;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  color: #333333;
  margin-top: 10px;
  margin-bottom: 10px;
}
.name-text {
  font-family: Avenir;
  font-size: 14px;
  font-weight: 350;
  line-height: 19.12px;
  color: #333333;
}
.chip {
  color: #ad6d08;
}
</style>
